<div class="form form--diagnosis-short" [ngClass]="getLevelClass()">
  <basic-label [noIndent]="true"></basic-label>
  <ng-container *ngFor="let subQuestion of questionItem.children">
    <dynamic-component
      [componentData]="{ question: subQuestion, loopIndex: loopIndex, customWidth: customWidth }"
    ></dynamic-component>
  </ng-container>
</div>
